/* eslint-disable react/no-unescaped-entities */
import * as React from "react";
import { Callout, CodeBlock, APIReferenceRelativeLink } from "../../markdown-components";

export const ScriptTagCallout = (props: { developmentRenderURL: string }) => (
  <Callout title="Direct script tag">
    The script tag URL can be found in the{" "}
    <APIReferenceRelativeLink path="/external-api-calls/installing">Installing</APIReferenceRelativeLink> section of your app's{" "}
    <b>API Reference</b>.
    <br />
    Your script tag needs <b>--development</b> added to your app-specific subdomain when working on your Development environment:
    <CodeBlock language="html">{`<script src="${props.developmentRenderURL}api/client/web.min.js" defer="defer"></script>`}</CodeBlock>
  </Callout>
);
